import { render } from "./BasicModal2b.vue?vue&type=template&id=781d948a"
import script from "./BasicModal2b.vue?vue&type=script&lang=js"
export * from "./BasicModal2b.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__